/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChartType, TooltipItem } from 'chart.js/dist/types/index';
import { usePercentagesFromArray } from 'hooks/usePercentagesFromArray';

const useChartTooltip = (tooltipItem: TooltipItem<ChartType>, unit: string, type: string) => {
  const peopleCount = tooltipItem.dataset.data;
  const tooltipIndex = tooltipItem.dataIndex;

  const getPecent = usePercentagesFromArray();

  const peopleCountData = peopleCount.map((item: any) => item);
  const dataPercentages = getPecent(peopleCountData);

  if (type === 'count') {
    return `${peopleCountData[tooltipIndex]?.toLocaleString()}${unit}`;
  } else if (type === 'percentage') {
    return `${dataPercentages[tooltipIndex].toFixed(1)}${unit}`;
  }

  return '';
};

export default useChartTooltip;
